import React, { createContext } from 'react';

interface Context {
  focusedAccountId: string | null;
  selectedItemName: string;
  updatedAt: string;
}

export const PerformanceReportingContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
  children: React.ReactNode;
}

export const PerformanceReportingProvider = ({ children, value }: Props) => (
  <PerformanceReportingContext.Provider value={value}>
    {children}
  </PerformanceReportingContext.Provider>
);
